import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { AlertProvider } from "./context/AlertContext";
import { OktaWrapper, PageSpinner } from "./components";
import { router } from "./router";
import "./assets/styles/globals.scss";

import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(document.getElementById("root")!);

export const PRIMARY_SILVER_COLOR = {
  100: "#F5F7F7",
  150: "#E3E5E5",
  200: "#E5E9EB",
  250: "#D3D6D6",
  300: "#CAD1D3",
  350: "#CBCDCB",
  400: "#BBC7CD",
  500: "#778F9C",
  600: "#85868C",
  700: "#5B5C61",
  900: "#222222",
  1000: "#000000",
};

export const SECONDARY_COLORS = {
  DARK_GREY: "#435254",
  VIOLET: "#A388BF",
  OCEAN_BLUE: "#3E7CA6",
};

export const PRIMARY_COLORS = {
  PRIMARY_GREEN: "#538184",
  PRIMARY_SILVER: PRIMARY_SILVER_COLOR[500],
  PRIMARY_BLACK: "#222222",
  PRIMARY_WHITE: "#FFFFFF",
  PRIMARY_DARK_GREEN: "#012A2D",
  PRIMARY_LIGHT_GREEN: "#E6F1EF",
  PRIMARY_ACCENT_GREEN: "#17E88F",
  PRIMARY_RED: "#E8445C",
  PRIMARY_MEDIUM_GREEN: "#003F2D",
  PRIMARY_LIGHT_RED: "#D2785A",
};

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      light: PRIMARY_COLORS.PRIMARY_LIGHT_GREEN,
      main: PRIMARY_COLORS.PRIMARY_GREEN,
      dark: PRIMARY_COLORS.PRIMARY_DARK_GREEN,
      contrastText: PRIMARY_COLORS.PRIMARY_WHITE,
    },
    secondary: {
      main: PRIMARY_COLORS.PRIMARY_WHITE,
      dark: PRIMARY_COLORS.PRIMARY_SILVER,
      contrastText: SECONDARY_COLORS.DARK_GREY,
    },
    success: {
      dark: PRIMARY_COLORS.PRIMARY_MEDIUM_GREEN,
      main: PRIMARY_COLORS.PRIMARY_ACCENT_GREEN,
    },
    text: {
      primary: PRIMARY_COLORS.PRIMARY_DARK_GREEN,
      secondary: SECONDARY_COLORS.DARK_GREY,
    },
  },
  typography: {
    fontFamily: "Calibre",

    button: {
      fontSize: "18px",
      lineHeight: "24px",
      textTransform: "none",
    },
  },
});

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <OktaWrapper>
        <AlertProvider>
          <Suspense fallback={<PageSpinner isOpen />}>
            <QueryClientProvider client={queryClient}>
              <RouterProvider router={router} />
            </QueryClientProvider>
          </Suspense>
        </AlertProvider>
      </OktaWrapper>
    </ThemeProvider>
  </React.StrictMode>
);
